<template>
  <div></div>
</template>

<script>
  import Vue from 'vue'

  export default {
    created () {
      this.$auth.logout({
        success: function () {
          // Disable push
          Vue.cordova.on('deviceready', () => {
            window.plugins.OneSignal.setSubscription(false)
          })
          this.$router.push({ name: 'Login' })
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Logout.vue?74829549